import { render, staticRenderFns } from "./ProcessSalesOrder.vue?vue&type=template&id=22ddf171&"
import script from "./ProcessSalesOrder.vue?vue&type=script&lang=js&"
export * from "./ProcessSalesOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports